import { useEffect, useState } from "react";
import useValidation from "../../hooks/useValidation";
import { SigningOfTheStatusType } from "../../static/types/commonTypes/signingOfTheStatusType";
import signingOfTheStatusSchema from "../../utils/validation/signingOfTheStatusValidationSchema";
import { format, parse, isValid } from "date-fns";

type SigningOfTheStatusProps = {
  checked: boolean;
  actNature: string[];
  actDateLabel: string;
  signingOfTheStatus: SigningOfTheStatusType;
  updateSigningOfTheStatus: (signingOfTheStatus: Partial<SigningOfTheStatusType>) => void;
  onValidationChange: (isValid: boolean) => void;
  showPlaceSignature: boolean;
//   placeSignature?: string;
};

export default function SigningOfTheStatus({
  checked,
  actNature,
  actDateLabel,
  signingOfTheStatus,
  updateSigningOfTheStatus,
  onValidationChange,
  showPlaceSignature = false,
}: SigningOfTheStatusProps) {
  const { errors, isValid: isDataValid } = useValidation(signingOfTheStatus, signingOfTheStatusSchema);

  useEffect(() => {
    onValidationChange(isDataValid);
  }, [isDataValid, onValidationChange]);

  useEffect(() => {
    updateSigningOfTheStatus({
      ...signingOfTheStatus,
      actNature: actNature[0],
    });
  }, []);

  const [selectedDate, setSelectedDate] = useState<string>("");

  useEffect(() => {
    if (signingOfTheStatus.actDate) {
      const parsedDate = parse(signingOfTheStatus.actDate, "dd/MM/yyyy", new Date()); // Parsing en format personnalisé
      setSelectedDate(isValid(parsedDate) ? format(parsedDate, "yyyy-MM-dd") : "");
    }
  }, [signingOfTheStatus.actDate]);

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const parsedDate = parse(e.target.value, "yyyy-MM-dd", new Date());
    const formattedDate = isValid(parsedDate) ? format(parsedDate, "dd/MM/yyyy") : "";
    updateSigningOfTheStatus({
      ...signingOfTheStatus,
      actDate: formattedDate,
    });
    setSelectedDate(e.target.value);
  };

  const openDatePicker = (id: string) => {
    const input = document.getElementById(id) as HTMLInputElement;
    input?.showPicker();
};

  return (
    <div className="container p-4">
      <div className="row mb-2">
        <label htmlFor="actNature" className="col-4 col-form-label fw-bold mb-1" style={{marginRight: '-100px'}}>
          Nature de l'acte <strong className="text-danger">*</strong>
        </label>
        <div className="col-6">
          <select
            className={`form-select ${checked && errors.actNature ? "is-invalid" : ""}`}
            id="actNature"
            onChange={(event) => updateSigningOfTheStatus({ actNature: event.target.value })}
            value={signingOfTheStatus.actNature}
          >
            {actNature.map((nature, index) => (
              <option key={index} value={nature}>
                {nature}
              </option>
            ))}
          </select>
          {checked && errors.actNature && (
            <div className="invalid-feedback">{errors.actNature}</div>
          )}
        </div>
      </div>

      <div className="row mb-2">
        <label htmlFor="actDate" className="col-4 col-form-label fw-bold mb-1" style={{marginRight: '-100px'}}>
          {actDateLabel} <span className="text-danger">*</span>
        </label>
        <div className="col-6">
          <input
            className={`form-control ${checked && errors.actDate ? "is-invalid" : ""}`}
            type="date"
            id="actDate"
            value={selectedDate}
            onChange={handleDateChange}
            onClick={() => openDatePicker("actDate")}
          />
          {checked && errors.actDate && (
            <div className="invalid-feedback">{errors.actDate}</div>
          )}
        </div>
      </div>

      {showPlaceSignature && (
        <div className="row mb-2">
          <label htmlFor="placeSignature" className="col-4 col-form-label fw-bold mb-1" style={{marginRight: '-100px'}}>
            Lieu de signature
          </label>
          <div className="col-6">
            <input
              className="form-control"
              type="text"
              id="placeSignature"
              value={signingOfTheStatus.placeSignature}
              onChange={(event) =>
                updateSigningOfTheStatus({ placeSignature: event.target.value })
              }
              placeholder="Lieu de signature"
            />
          </div>
        </div>
      )}
    </div>
  );
}
